import { alas, status } from '@/alas';
import { defineComponent, reactive, computed, onMounted, watch } from '@vue/composition-api';
export default defineComponent({
    setup() {
        // ================
        //
        // state
        //
        let $ = reactive({
            user: status.fetch('user'),
            config: status.fetch('config'),
            contact: alas.make('user', 'contact').$init(),
            validate: false
        });
        // ================
        //
        // watch
        //
        watch(() => contact.value.type, () => {
            $.contact.content = $.config.contactTypes.find(t => t.value === contact.value.type).defaultText;
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            if ($.user.logged) {
                $.contact.person = $.user.email;
            }
        });
        // ================
        //
        // methods
        //
        let fail = computed(() => $.contact.$o.create.error);
        let done = computed(() => $.contact.$o.create.done);
        let loading = computed(() => $.contact.$o.create.loading);
        let contact = computed(() => $.contact);
        let contactTypes = computed(() => $.config.contactTypes);
        // ================
        //
        // methods
        //
        let submit = () => {
            $.contact.$o.create.start({
                user: $.user.logged ? $.user.name : 'guest'
            });
        };
        // ================
        //
        // done
        //
        return {
            $,
            fail,
            done,
            contact,
            loading,
            submit,
            contactTypes
        };
    }
});
